<template>
  <v-content>
    <v-container style="max-width: 1000px; background-color: white">
      <v-layout column>
        <v-layout align-center class="mb-4">
          <v-flex xs2 class="hidden-xs-only">
            <v-layout
              align-center
              column
              class="mt-3"
              @click="goToSoraban"
              style="cursor: pointer"
            >
              <img
                :src="require('@/assets/logo-sharp.png')"
                style="height: 35px"
              />
              <p class="primary--text title font-weight-bold mt-2 ml-1">
                Soraban
              </p>
            </v-layout>
          </v-flex>
          <v-spacer />
          <v-layout column>
            <v-flex
              class="text-xs-center display-2 primary--text font-weight-bold mb-1"
              :class="$vuetify.breakpoint.smAndUp ? 'display-2' : 'display-1'"
            >
              Create Firm
            </v-flex>
          </v-layout>
          <v-spacer />
          <v-layout column align-end>
            <v-btn
              class="default-input primary text-none hidden-xs-only"
              @click="scheduleCall()"
            >
              <v-layout align-center>
                <i class="material-icons-outlined mr-2" style="font-size: 18px">
                  calendar_today
                </i>
                Book 15-min
              </v-layout>
            </v-btn>
            <v-btn
              outline
              class="default-input primary--text text-none hidden-xs-only"
              @click="$router.push('/product-overview')"
            >
              <v-layout align-center> Create Firm </v-layout>
            </v-btn>
          </v-layout>
        </v-layout>
        <v-layout column justify-center align-center>
          <v-flex xs12 sm6 class="form-container">
            <v-layout class="text-xs-left my-4" wrap>
              Enter in the following information to get started!
            </v-layout>

            <v-divider />
            <v-form ref="form1" v-model="userValid" class="mt-4">
              <v-layout>
                <v-flex xs6 class="pr-1">
                  <div class="text-xs-left">First Name</div>
                  <v-text-field
                    class="default-input"
                    solo
                    name="first-name"
                    label="Sam"
                    type="text"
                    v-model="firstName"
                    required
                    :rules="fieldRules"
                  />
                </v-flex>
                <v-flex xs6 class="pl-1">
                  <div class="text-xs-left">Last Name</div>
                  <v-text-field
                    class="default-input"
                    solo
                    name="last-name"
                    label="Smith"
                    type="text"
                    v-model="lastName"
                    required
                    :rules="fieldRules"
                  />
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12>
                  <div class="text-xs-left">Email</div>
                  <v-text-field
                    class="default-input"
                    solo
                    name="email"
                    label="your.best@email.com"
                    type="email"
                    v-model="email"
                    :rules="emailRules"
                    required
                  />
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12>
                  <div class="text-xs-left">Firm name</div>
                  <v-text-field
                    class="default-input"
                    solo
                    name="firmName"
                    label="Demo Firm, LLC"
                    type="text"
                    v-model="firmName"
                    :rules="fieldRules"
                    required
                  />
                </v-flex>
              </v-layout>
              <v-layout>
                <v-btn
                  class="primary text-none"
                  style="border-radius: 2px"
                  block
                  larged
                  @click="submit"
                  :loading="loading"
                  :disabled="!userValid"
                >
                  Create Firm
                </v-btn>
              </v-layout>
              <v-layout wrap class="caption grey--text mt-2">
                <span class="text-xs-left"
                  ><b>No payment required.</b> By clicking "Create Firm", I
                  agree to Soraban's
                  <a href="https://www.soraban.com/#terms" target="_blank"
                    >Terms</a
                  >
                  and
                  <a href="https://www.soraban.com/#policy" target="_blank"
                    >Privacy Policy</a
                  >.</span
                >
              </v-layout>
              <v-layout wrap class="mt-5">
                <v-spacer />
                <span class="text-xs-left have-an-account__question"
                  >Already have an account?
                  <a @click="$router.push('signin')">Sign in here.</a></span
                >
              </v-layout>
            </v-form>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-container>
  </v-content>
</template>
<script>
import { firebase } from '@firebase/app';
import '@firebase/auth';
import API from '@/api';
import { emailRules } from '@/constants/rules';
import UtilsMixins from '../../mixins/UtilsMixins';

export default {
  name: 'CreateFirm',
  data() {
    return {
      userValid: false,
      email: '',
      firstName: '',
      lastName: '',
      firmName: '',
      fieldRules: [v => !!v || 'This field is required'],
      emailRules,
      signedUp: false,
      loading: false,
    };
  },
  mixins: [UtilsMixins],
  methods: {
    async submit() {
      try {
        this.loading = true;
        const response = await API.user.createFirm({
          email: this.email,
          fname: this.capitalizeWords(this.firstName),
          lname: this.capitalizeWords(this.lastName),
          firmName: this.firmName,
        });
        if (response.data.error) {
          console.log(response.data.error);
          this.$store.dispatch('application/setErrorNotification', {
            message: response.data.error,
          });
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message:
              'Thank you for signing up for the demo! You will soon receive an email with the login information with instructions.',
          });
          this.signedUp = true;
          this.email = '';
          this.firstName = '';
          this.lastName = '';
          this.firmName = '';
          this.$refs.form1.resetValidation();
        }
      } catch (e) {
        this.$store.dispatch('application/setErrorNotification', {
          message: e.message,
        });
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    scheduleCall() {
      window.open('https://calendly.com/soraban/15-min-demo', '_blank');
    },
    goToSoraban() {
      window.location.href = 'https://www.soraban.com';
    },
  },
};
</script>

<style lang="postcss" scoped>
.form-container {
  width: 600px;
}
.have-an-account__question {
  color: #1d2b4c;
}
.message-title {
  line-height: 30px !important;
}
</style>
